import { render, staticRenderFns } from "./Terms&ConditionContent.vue?vue&type=template&id=3918488c&"
import script from "./Terms&ConditionContent.vue?vue&type=script&lang=js&"
export * from "./Terms&ConditionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports